import { useEffect, useState, useCallback } from "react";
import { TriangleAlert } from "lucide-react";
import api, { timeAgo } from "../lib/api";
import { PriorityBadge } from "../components/badges";

const BORDER = {
  critical: "border-l-red-500",
  high: "border-l-red-500/70",
  normal: "border-l-amber-400/60",
  low: "border-l-neutral-600",
};

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);

  const load = useCallback(() => {
    api.get("/alerts").then(({ data }) => setAlerts(data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div data-testid="alerts-page" className="relative space-y-6">
      <div aria-hidden="true" className="pointer-events-none absolute -top-28 left-1/3 h-64 w-[44rem] -translate-x-1/2 rounded-full bg-[#00E5FF]/[0.05] blur-3xl" />
      <div className="relative">
        <h1 className="font-heading text-4xl font-bold tracking-tight text-white">Alertes</h1>
        <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">Événements importants signalés par les projets</p>
      </div>

      <div className="space-y-3">
        {alerts.length === 0 && (
          <div className="border border-border bg-card px-5 py-10 text-center font-mono text-xs text-neutral-600">
            Aucune alerte — tous les systèmes sont nominaux
          </div>
        )}
        {alerts.map((a) => (
          <div key={a.id} data-testid="alert-item"
            className={`flex items-center justify-between border border-white/10 border-l-4 bg-[#121212]/90 px-5 py-4 backdrop-blur-sm ${BORDER[a.priority] || BORDER.normal} ${a.priority === "critical" ? "shadow-[0_0_18px_rgba(239,68,68,0.12)]" : ""}`}>
            <div className="flex items-center gap-4">
              <TriangleAlert size={16} className={a.priority === "high" || a.priority === "critical" ? "text-red-400" : "text-amber-300"} />
              <div>
                <div className="font-mono text-sm text-white">
                  <span className="text-neutral-500">[{a.category}]</span> {a.message}
                </div>
                <div className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-600">
                  {a.source} · {timeAgo(a.created_at)}
                </div>
              </div>
            </div>
            <PriorityBadge priority={a.priority} />
          </div>
        ))}
      </div>
    </div>
  );
}
